var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.708 17.735a.725.725 0 0 0-.201.421.718.718 0 0 0 .089.458c.08.144.195.248.345.317.15.068.306.086.467.053L18 15.586l16.592 3.398a.737.737 0 0 0 .467-.053.734.734 0 0 0 .345-.317c.08-.139.111-.3.09-.458a.732.732 0 0 0-.202-.421L18.547.235a.751.751 0 0 0-1.096 0L.708 17.734Z"
  })));
};
export default SvgLogoWhite;